export default __webpack_public_path__ + "static/media/background3.c2c183f1.svg";